<template>
  <!-- 此模块为车辆离线原因弹框 -->
  <div class="OffLineReasonDialog">
    <van-popup v-model="showDialog">
      <div class="content">
        <div class="title">提示</div>
        <div class="introduce">
          <div class="introduce-title">
            车辆离线
          </div>
          <div class="introduce-content">
            车辆安装的定位设备没有上报位置信息
          </div>
        </div>
        <div class="introduce">
          <div class="introduce-title">
            离线原因
          </div>
          <div class="introduce-content">
            长时间停车设备休眠；车辆所在地区信 号弱；设备故障；设备未开启；设备未 续费停用；设备流量卡松动或流量用完 等。
          </div>
        </div>
        <div class="introduce">
          <div class="introduce-title">
            解决办法
          </div>
          <div class="introduce-content">
            稍后再试或联系设备服务商恢复。
          </div>
        </div>
        <div class="btn flex" @click="showDialog=false">知道了</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    return {
      showDialog: false,
    };
  },
  computed: {},
  created () {},
  mounted () {},
  watch: {},
  methods: {
    /**
     * 显示车辆离线原因弹框
    */
    showPopup () {
      this.showDialog = true
    },

  },
  components: {}
};
</script>

<style scoped lang="scss">
.OffLineReasonDialog>:first-child {
  background-color: rgba(0,0,0,.4)
}
.OffLineReasonDialog>:nth-child(2) {
  border-radius: 12px;
  width: 80%;
}
.OffLineReasonDialog {
  .content {
    padding: 30px 30px;
    background-color: #ffffff;
    .title {
      color: #282828;
      font-size: 34px;
      font-weight: bold;
      text-align: center;
    }
    .introduce {
      padding-bottom: 20px;
      font-size: 28px;
      .introduce-title {
        color: #282828;
        padding-bottom: 20px;
        font-weight: bold;
      }
      .introduce-content {
        color: #656565
      }
    }
    .btn {
      background-color: #5572FD;
      margin: 0 auto;
      color: #ffffff;
      border-radius: 45px;
      font-size: 28px;
      width: 50%;
      height: 80px;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
    }
  }
}
</style>
